"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
var get_1 = __importDefault(require("lodash/get"));
var api_wrapper_1 = require("../../api/api-wrapper");
var error_handling_1 = require("../../error-handling");
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var helper_const_1 = require("../../services/helper.const");
var translation_1 = __importDefault(require("../../translation"));
var variables_const_1 = require("../../variables.const");
var checkout_const_1 = require("./checkout.const");
var contract_modules_1 = require("./contract-modules");
var Checkout = /** @class */ (function () {
    function Checkout() {
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.errorHandling = object_service_1.ObjectService.getInstance(error_handling_1.ErrorHandling);
        this.settings = variables_const_1._settings;
        this.termDefaultKeyForSwitcher = 'termValue';
        this.maximumNumberOfOfferings = 3;
        this.termSwitcherExists = false;
        this.offerings = [];
        this.contractModules = new contract_modules_1.ContractModules();
    }
    Checkout.prototype.resetSelectedModules = function () {
        this.contractModules.resetModules();
    };
    Checkout.prototype.loadModule = function (settings) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __awaiter(this, void 0, void 0, function () {
            var _p;
            var _this = this;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        $('#refObjectId').before(this.helper.getLoader());
                        this.settings = settings ? settings : variables_const_1._settings;
                        this.helper.hideRefObjects([
                            '#' + ((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.featuredRefId),
                            '#' + ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.checkout) === null || _d === void 0 ? void 0 : _d.refObjectSubdescription),
                        ]);
                        this.maximumNumberOfOfferings =
                            ((_e = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _e === void 0 ? void 0 : _e.maximumNumberOfOfferings) ||
                                ((_f = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.checkout) === null || _f === void 0 ? void 0 : _f.maximumNumberOfOfferings) ||
                                this.maximumNumberOfOfferings;
                        if (variables_const_1.environment === 'dev') {
                            console.info('If you want to use directly the magicline contract object just define some parent object as [data-membership="<<CONTRACTID>>OR<<CONTRACTNAME>>"] OR ', 'And than you can use in the children e.g. custom attributes like [data-get="price"]');
                        }
                        this.studioId = localStorage.getItem('Location') || ((_g = this.settings) === null || _g === void 0 ? void 0 : _g.studioId);
                        this.studioName =
                            localStorage.getItem('StudioName') || ((_h = this.settings) === null || _h === void 0 ? void 0 : _h.studioName);
                        if (!((_j = this.studioId) === null || _j === void 0 ? void 0 : _j.length)) {
                            console.error('No studio id is set');
                            return [2 /*return*/];
                        }
                        if (!((_k = this.studioName) === null || _k === void 0 ? void 0 : _k.length)) {
                            console.info('No studio name is set');
                        }
                        localStorage.setItem('Location', this.studioId);
                        localStorage.setItem('studioId', this.studioId);
                        localStorage.setItem('StudioName', this.studioName);
                        localStorage.setItem('studioName', this.studioName);
                        _p = this;
                        return [4 /*yield*/, this.apiWrapper.getOfferings(this.studioId)];
                    case 1:
                        _p.offerings = _q.sent();
                        if (((_l = this.offerings) === null || _l === void 0 ? void 0 : _l.length) === 0 || this.offerings === undefined) {
                            this.errorHandling.showErrorMessage("No offerings found for studio \"".concat(this.studioId, "\" using the \"").concat(this.settings.technologyType, "\" API"));
                            return [2 /*return*/];
                        }
                        else {
                            this.errorHandling.hideErrorMessage();
                        }
                        if (!(((_m = this.settings) === null || _m === void 0 ? void 0 : _m.section) === 'modules')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.contractModules.loadModule(this.settings, this.offerings)];
                    case 2:
                        _q.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(((_o = this.settings) === null || _o === void 0 ? void 0 : _o.section) === 'checkout')) return [3 /*break*/, 5];
                        console.log(this.offerings);
                        this.prepareTermswitcher(this.offerings);
                        return [4 /*yield*/, this.filloutOfferingData(this.offerings)];
                    case 4:
                        _q.sent();
                        //remove eventual default events on the button
                        $('#Membership-Submit').off();
                        //save membership info continue with next section
                        $('#Membership-Submit').on('click', function (event) {
                            _this.submitMembership(event);
                        });
                        _q.label = 5;
                    case 5:
                        this.helper.deleteLoadingScreen();
                        return [2 /*return*/];
                }
            });
        });
    };
    Checkout.prototype.prepareTermswitcher = function (offerings) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if ((_b = $('#' + ((_a = checkout_const_1.InputFieldMappingTable === null || checkout_const_1.InputFieldMappingTable === void 0 ? void 0 : checkout_const_1.InputFieldMappingTable.termSwitcher) === null || _a === void 0 ? void 0 : _a.id))) === null || _b === void 0 ? void 0 : _b.length) {
            this.termSwitcherExists = true;
            var termSwitcher = $('#' + ((_c = checkout_const_1.InputFieldMappingTable === null || checkout_const_1.InputFieldMappingTable === void 0 ? void 0 : checkout_const_1.InputFieldMappingTable.termSwitcher) === null || _c === void 0 ? void 0 : _c.id));
            if (termSwitcher === null || termSwitcher === void 0 ? void 0 : termSwitcher.length) {
                var numberOfTerms = offerings
                    .map(function (a) { return a.terms.length; })
                    .reduce(function (partialSum, a) { return partialSum + a; }, 0);
                if (numberOfTerms === offerings.length) {
                    console.error('We have no terms to switch to therefore termswitcher is hidden', offerings.length);
                }
                var termKey = ((_e = (_d = this.settings) === null || _d === void 0 ? void 0 : _d.checkout) === null || _e === void 0 ? void 0 : _e.termSwitcherAttribute) || 'termValue';
                if (termKey === null || termKey === void 0 ? void 0 : termKey.length) {
                    this.termDefaultKeyForSwitcher = termKey;
                }
                var tabs = termSwitcher.find('[data-set]');
                var terms = offerings.filter(function (a) { return a.terms.length; }).map(function (a) { return a.terms; }).flat();
                var numberOfTabs = [];
                var _loop_1 = function (tab) {
                    var attr = tab.getAttribute('data-set');
                    var offeringTerm = undefined;
                    var hasTerms = terms.some(function (a) {
                        offeringTerm = a[_this.termDefaultKeyForSwitcher];
                        return +a[_this.termDefaultKeyForSwitcher] === +attr;
                    });
                    if (offeringTerm === undefined) {
                        hasTerms = offerings.some(function (a) { return a[_this.termDefaultKeyForSwitcher].toLowerCase().includes(attr.toLowerCase()); });
                    }
                    if (hasTerms === false && tab) {
                        // Remove tabs that have no terms to prevent confusion
                        console.error(hasTerms);
                        tab.style.display = 'none';
                    }
                    else {
                        numberOfTabs.push(tab);
                    }
                };
                for (var _i = 0, _f = tabs.get(); _i < _f.length; _i++) {
                    var tab = _f[_i];
                    _loop_1(tab);
                }
                if (numberOfTabs.length === 1) {
                    numberOfTabs[0].click();
                    termSwitcher.hide();
                }
                if (tabs.length) {
                    tabs.on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!((_b = (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.getAttribute('data-set')) === null || _b === void 0 ? void 0 : _b.length)) return [3 /*break*/, 2];
                                    this.termSwitcherValue =
                                        event.currentTarget.getAttribute('data-set');
                                    console.log(this.termSwitcherValue);
                                    return [4 /*yield*/, this.filloutOfferingData(offerings)];
                                case 1:
                                    _c.sent();
                                    _c.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    var currentlyActive = termSwitcher.find('.w--current[data-set]');
                    if (currentlyActive === null || currentlyActive === void 0 ? void 0 : currentlyActive.length) {
                        //find default selected tab / term
                        this.termSwitcherValue = currentlyActive.attr('data-set');
                    }
                }
                else if (variables_const_1.environment === 'dev') {
                    console.info('You have defined a termswitcher but no tabs. Please add data-set="termvalue". If you want to change the "termvalue" add a data-term-key to your app Termswitcher object');
                }
            }
            else if (variables_const_1.environment === 'dev') {
                console.info('You have no term switcher defined. If you want to please add the term-switcher id to the tabs that should trigger a term change');
            }
        }
    };
    Checkout.prototype.userSelectedOffering = function (offering, term) {
        var _a;
        this.selectedTerm = term;
        this.selectedOffering = offering;
        this.updateLocalStorageItems();
        if ((_a = $('#Membership-Submit')) === null || _a === void 0 ? void 0 : _a.length) {
            this.helper.scrollToPageElementOffset('#Membership-Submit', 500, 1000);
        }
    };
    Checkout.prototype.submitMembership = function (event) {
        var _a, _b, _c;
        if (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        if (this.selectedOffering && this.selectedTerm) {
            this.errorHandling.hideErrorMessage();
            this.updateLocalStorageItems();
            if (!((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.noRedirect)) {
                window.location.href =
                    (_c = this.settings.redirect) !== null && _c !== void 0 ? _c : '/membership/personliche-daten';
            }
        }
        else {
            this.errorHandling.showErrorMessage(translation_1.default.t('selectContract'));
            console.error('No Offering selected');
        }
    };
    Checkout.prototype.updateLocalStorageItems = function () {
        var _a, _b, _c, _d;
        if ((_a = this.selectedTerm) === null || _a === void 0 ? void 0 : _a.defaultContractStartDate) {
            localStorage.setItem('startDate', String(this.selectedTerm.defaultContractStartDate));
            localStorage.setItem('contract.startDate', String(this.selectedTerm.defaultContractStartDate));
        }
        if ((_b = this.selectedTerm) === null || _b === void 0 ? void 0 : _b.contractStartDateOfUse) {
            localStorage.setItem('preuseDate', String(this.selectedTerm.contractStartDateOfUse));
            localStorage.setItem('contract.preuseDate', String(this.selectedTerm.contractStartDateOfUse));
        }
        localStorage.setItem('aov', JSON.stringify((0, helper_const_1._CalculateAOV)(this.selectedTerm)));
        localStorage.setItem('contract.aov', JSON.stringify((0, helper_const_1._CalculateAOV)(this.selectedTerm)));
        localStorage.setItem('termDuration', String(this.selectedTerm.termValue + ' ' + this.selectedTerm.termUnit));
        localStorage.setItem('contract.rateBundleTermDuration', String(this.selectedTerm.termValue + ' ' + this.selectedTerm.termUnit));
        localStorage.setItem('Memberships', String(this.selectedTerm.id));
        localStorage.setItem('contract.rateBundleTermId', String(this.selectedTerm.id));
        localStorage.setItem('membershipName', String(this.selectedOffering.name));
        localStorage.setItem('contract.rateBundleName', String(this.selectedOffering.name));
        localStorage.setItem('membershipPrice', String(this.selectedTerm.price));
        localStorage.setItem('contract.rateBundlePrice', String(this.selectedTerm.price));
        localStorage.setItem('membershipMonth', String(this.selectedTerm.termValue));
        localStorage.setItem('contract.rateBundleTermValue', String(this.selectedTerm.termValue));
        if ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.checkout) === null || _d === void 0 ? void 0 : _d.callback) {
            this.settings.checkout.callback({
                offerings: this.offerings,
                selectedOffering: this.selectedOffering,
                selectedTerm: this.selectedTerm,
            });
        }
    };
    Checkout.prototype.createSubDescriptionRefObject = function (subDescription, htmlEle) {
        var _a, _b, _c, _d;
        if ((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.refObjectSubdescription) {
            var refObject = $('#' + ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.checkout) === null || _d === void 0 ? void 0 : _d.refObjectSubdescription));
            if (refObject.length) {
                var entries = subDescription.replace(/\*/gi, '').split('\n');
                $('#' + this.settings.checkout.refObjectSubdescription).appendTo('body'); // ref object to safe place
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    var subDescriptionEntry = this.helper.createClonesForRefObjectId([], '#' + this.settings.checkout.refObjectSubdescription);
                    var replaceText = subDescriptionEntry.find('[data-get="item"]');
                    (replaceText.length === 0 ? subDescriptionEntry : replaceText).html(entry.replace(/^[\*\-\s]*/gi, '').trim());
                    $(htmlEle).append(subDescriptionEntry);
                }
            }
            else if (variables_const_1.environment === 'dev') {
                console.log('data-get="item" is missing for subdescription', htmlEle);
            }
        }
        else if (variables_const_1.environment === 'dev') {
            console.log('Subdescription is accessed but no refobject is provided');
        }
    };
    Checkout.prototype.featuredOffering = function () {
        var featuredCard = $('[data-featured="true"]');
        if (featuredCard === null || featuredCard === void 0 ? void 0 : featuredCard.length) {
            var parent_1 = featuredCard.parent();
            if (parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.length) {
                var totalChildren = parent_1.children().length;
                if (totalChildren == 2) {
                    // Move featured child to the end if there are 2 children
                    parent_1.append(featuredCard);
                }
                else if (totalChildren > 2) {
                    // Move featured child to the middle if there are more than 2 children
                    var middleIndex = Math.floor(totalChildren / 2);
                    parent_1
                        .children()
                        .eq(middleIndex - 1)
                        .after(featuredCard);
                }
            }
        }
    };
    Checkout.prototype.filloutOfferingData = function (offerings) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __awaiter(this, void 0, void 0, function () {
            var termSwitcherIsName, numberOfClickablePanes, termRefObjects, refObjectId, refObject, wrapper, featuredId, _i, offerings_1, offering, terms, _u, terms_1, term, id, footNoteTermValue, getOfferingPanes, _loop_2, this_1, _v, getOfferingPanes_1, offeringPane;
            var _this = this;
            return __generator(this, function (_w) {
                termSwitcherIsName = ['name', 'recurringOffering'].includes((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.termSwitcherAttribute);
                //Termswitcher also switch offerings -> only relevant for name and recurringOffering
                if (this.termSwitcherExists &&
                    ((_c = this.termDefaultKeyForSwitcher) === null || _c === void 0 ? void 0 : _c.length) &&
                    termSwitcherIsName) {
                    offerings = JSON.parse(JSON.stringify(offerings)).filter(function (a) {
                        return String(a[_this.termDefaultKeyForSwitcher]).toLowerCase().includes(_this.termSwitcherValue.toLowerCase());
                    });
                }
                numberOfClickablePanes = 0;
                termRefObjects = (_e = (_d = this.settings) === null || _d === void 0 ? void 0 : _d.checkout) === null || _e === void 0 ? void 0 : _e.termSwitcherRefObjects;
                refObjectId = termRefObjects && termRefObjects[this.termSwitcherValue]
                    ? '#' + termRefObjects[this.termSwitcherValue]
                    : '#' + ((_f = this.settings) === null || _f === void 0 ? void 0 : _f.refObjectId);
                if (refObjectId && $(refObjectId).length) {
                    refObject = $(refObjectId)[0];
                    (0, helper_const_1._MoveRefObjectButKeepLinkToWrapper)(refObject);
                    wrapper = refObject['wrapperLink'];
                    if ((_g = $("[data-wrapper='".concat(this.termSwitcherValue, "']"))) === null || _g === void 0 ? void 0 : _g.length) {
                        wrapper = $("[data-wrapper='".concat(this.termSwitcherValue, "']"));
                    }
                    featuredId = void 0;
                    if ($('#' + ((_j = (_h = this.settings) === null || _h === void 0 ? void 0 : _h.checkout) === null || _j === void 0 ? void 0 : _j.featuredRefId)).length) {
                        featuredId = '#' + ((_l = (_k = this.settings) === null || _k === void 0 ? void 0 : _k.checkout) === null || _l === void 0 ? void 0 : _l.featuredRefId);
                        (0, helper_const_1._MoveRefObjectButKeepLinkToWrapper)($(featuredId)[0]);
                    }
                    $('[data-wrapper]').html('');
                    wrapper.html('');
                    for (_i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
                        offering = offerings_1[_i];
                        terms = offering.terms;
                        // Apply slicing if maximumNumberOfTerms is defined and the termSwitcherAttribute is not 'name' or 'recurringOffering'.
                        if (((_o = (_m = this === null || this === void 0 ? void 0 : this.settings) === null || _m === void 0 ? void 0 : _m.checkout) === null || _o === void 0 ? void 0 : _o.maximumNumberOfTerms) &&
                            !termSwitcherIsName) {
                            terms = terms.slice(0, this.settings.checkout.maximumNumberOfTerms);
                        }
                        for (_u = 0, terms_1 = terms; _u < terms_1.length; _u++) {
                            term = terms_1[_u];
                            //filter terms that are not allowed by termswitcher
                            if (this.termSwitcherExists &&
                                ((_p = this.termDefaultKeyForSwitcher) === null || _p === void 0 ? void 0 : _p.length) &&
                                !termSwitcherIsName) {
                                if (String(term[this.termDefaultKeyForSwitcher]) !==
                                    String(this.termSwitcherValue)) {
                                    continue;
                                }
                            }
                            id = refObjectId;
                            if (featuredId &&
                                ((_q = offering === null || offering === void 0 ? void 0 : offering.footnote) === null || _q === void 0 ? void 0 : _q.length) &&
                                (offering === null || offering === void 0 ? void 0 : offering.footnote.split(':').length) > 1) {
                                footNoteTermValue = +(offering === null || offering === void 0 ? void 0 : offering.footnote.split(':')[1].replace(/[a-z\s]/gi, ''));
                                if (footNoteTermValue) {
                                    if (this.termSwitcherValue && +this.termSwitcherValue === footNoteTermValue) {
                                        id = featuredId;
                                    }
                                    else if (footNoteTermValue === +(term === null || term === void 0 ? void 0 : term.termValue)) {
                                        id = featuredId;
                                    }
                                }
                                else {
                                    id = featuredId;
                                }
                            }
                            wrapper.append(this.helper.createClonesForRefObjectId([
                                { key: 'data-membership', value: String(offering.id) },
                                { key: 'data-clickable', value: String(true) },
                                { key: 'data-featured', value: String(id === featuredId) },
                                { key: 'data-term-id', value: String(term.id) },
                            ], id, true));
                        }
                    }
                }
                this.featuredOffering();
                getOfferingPanes = $('[data-membership]').get();
                _loop_2 = function (offeringPane) {
                    var membershipId = offeringPane.getAttribute('data-membership');
                    var termId = offeringPane.getAttribute('data-term-id');
                    var offering = offerings.find(function (a) {
                        return a.terms.some(function (b) { return String(b.id) === String(membershipId); }) ||
                            String(a.id) === String(membershipId) ||
                            a.name.toLowerCase() === membershipId.toLowerCase();
                    });
                    if (offering === undefined) {
                        console.error('No contract for requested membership gonna hide membership offering', membershipId, offering);
                        if (((_s = (_r = this_1.settings) === null || _r === void 0 ? void 0 : _r.checkout) === null || _s === void 0 ? void 0 : _s.modeIfNoContractIsSet) === 'hideSubmit') {
                            var submitButton = offeringPane.querySelector('[data-submitbutton="true"]');
                            if (submitButton) {
                                submitButton.style.display = 'none';
                            }
                        }
                        else {
                            offeringPane.style.display = 'none';
                        }
                        return "continue";
                    }
                    var term = offering.terms.find(function (a) {
                        return String(a.id) === termId ||
                            String(a.id) === membershipId ||
                            String(a === null || a === void 0 ? void 0 : a.name).toLowerCase() === membershipId.toLowerCase();
                    });
                    if (term === undefined) {
                        if ((_t = this_1.termSwitcherValue) === null || _t === void 0 ? void 0 : _t.length) {
                            term = offering.terms.find(function (a) {
                                return String(a[_this.termDefaultKeyForSwitcher]).includes(_this.termSwitcherValue);
                            });
                            console.log('Find offering based on ', this_1.termSwitcherValue, this_1.termDefaultKeyForSwitcher);
                        }
                        if (term === undefined) {
                            term = offering.terms[0];
                            console.error('This offering has not the desired term', offering, this_1.termSwitcherValue);
                        }
                    }
                    if (offeringPane.getAttribute('data-clickable')) {
                        numberOfClickablePanes++;
                        var submitButton = offeringPane.querySelector('[data-submitbutton]');
                        if (submitButton) {
                            submitButton.addEventListener('click', function () {
                                _this.userSelectedOffering(offering, term);
                                _this.submitMembership();
                            });
                        }
                        else {
                            offeringPane.addEventListener('click', function (event) {
                                var _a;
                                $('[data-clickable]').removeAttr('selected-term');
                                (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.setAttribute('selected-term', true);
                                _this.userSelectedOffering(offering, term);
                            });
                        }
                    }
                    var mapping = {
                        name: offering.name,
                        price: translation_1.default.transformCurrency(term.price),
                        interval: term.termValue +
                            ' ' +
                            translation_1.default.t(term.termValue > 1 ? term.termUnit + 'S' : term.termUnit),
                        termPaymentFrequency: (term.paymentFrequencyValue === 1 ? translation_1.default.t('per') : term.paymentFrequencyValue) +
                            ' ' +
                            translation_1.default.t(term.paymentFrequencyValue > 1
                                ? term.paymentFrequencyUnit + 'S'
                                : term.paymentFrequencyUnit),
                    };
                    var getters = Object.keys(mapping).reduce(function (a, v) {
                        var _a;
                        return (__assign(__assign({}, a), (_a = {}, _a[v] = offeringPane.querySelector("[data-get=\"".concat(v, "\"]")), _a)));
                    }, {});
                    for (var key in getters) {
                        if (getters[key]) {
                            getters[key].innerHTML = String(mapping[key]);
                        }
                        else if (variables_const_1.environment === 'dev') {
                            console.info("Offering pane is missing getter attributes: [data-get=\"".concat(key, "\"] wont be set for"), offeringPane);
                        }
                    }
                    //other tags that are not part of the mapping table
                    offeringPane.querySelectorAll("[data-term]").forEach(function (a) {
                        var requested = a.getAttribute('data-term');
                        if ((requested === null || requested === void 0 ? void 0 : requested.length) && (0, get_1.default)(term, requested)) {
                            var value = (0, get_1.default)(term, requested);
                            if (requested === 'paymentFrequencyValue') {
                                a.innerHTML = translation_1.default.t(value === 1 ? 'per' : value);
                            }
                            else if (requested === 'price') {
                                a.innerHTML = translation_1.default.transformCurrency(value);
                            }
                            else if (requested === null || requested === void 0 ? void 0 : requested.length) {
                                a.innerHTML = translation_1.default.t(value);
                            }
                        }
                    });
                    var offerGetters = offeringPane.querySelectorAll("[data-get]");
                    offerGetters.forEach(function (a) {
                        var requested = a.getAttribute('data-get');
                        if ((requested === null || requested === void 0 ? void 0 : requested.length) && (0, get_1.default)(offering, requested)) {
                            if (requested === 'subDescription') {
                                _this.createSubDescriptionRefObject(offering.subDescription, a);
                            }
                            else {
                                a.innerHTML = translation_1.default.t((0, get_1.default)(offering, requested));
                            }
                        }
                        else if (variables_const_1.environment === 'dev') {
                            console.info("Your requested data [data-get]=\"".concat(requested, "\" doesn't exist on "), offering);
                        }
                    });
                };
                this_1 = this;
                for (_v = 0, getOfferingPanes_1 = getOfferingPanes; _v < getOfferingPanes_1.length; _v++) {
                    offeringPane = getOfferingPanes_1[_v];
                    _loop_2(offeringPane);
                }
                if (variables_const_1.environment === 'dev') {
                    if ((offerings === null || offerings === void 0 ? void 0 : offerings.length) === 0) {
                        console.error("You have NO clickable offering panes!! Customer can't choose an offer", 'Make at least one clickable by adding the attribute [data-clickable="true"] to at least one data-membership=\'offerID\' element', getOfferingPanes);
                    }
                    else if (numberOfClickablePanes < (offerings === null || offerings === void 0 ? void 0 : offerings.length)) {
                        console.info('You have more offerings (' +
                            (offerings === null || offerings === void 0 ? void 0 : offerings.length) +
                            ') than clickable panes (' +
                            numberOfClickablePanes +
                            '). You might want to add some [data-clickable="true"] otherwise the customer cant buy some of your offers');
                    }
                    else if (numberOfClickablePanes > (offerings === null || offerings === void 0 ? void 0 : offerings.length)) {
                        console.info('You have less offerings (' +
                            (offerings === null || offerings === void 0 ? void 0 : offerings.length) +
                            ') than clickable panes (' +
                            numberOfClickablePanes +
                            ').. If you have multiple sections where the user can select the contract this might be wanted behaviour');
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    return Checkout;
}());
exports.Checkout = Checkout;
